<style lang="scss" scoped>
  .services-block {
    position: relative;
    z-index: 2;
    margin: 0 0 152px;

    @include media(max, lg) {
      padding: 0 20px;
    }
  }

  .title {
    margin: 0 auto 40px;
    padding: 0 30px 0 150px;
    width: 1320px;
    max-width: 100%;
    font-size: 44px;
    line-height: 1.09;
    font-weight: 600;
    letter-spacing: 0.005em;

    @include media(max, xl) {
      padding-left: 60px;

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 60px;
      }
    }

    @include media(max, lg) {
      padding: 0;
    }

    @include media(max, md) {
      margin-bottom: 30px;
      font-size: 32px;
      line-height: 1.12;
    }
  }

  .wrapper {
    margin: 0 auto;
    padding: 60px 30px 0 150px;
    width: 1320px;
    max-width: 100%;
    min-height: 560px;
    background: #242429;
    border-radius: 20px;
    display: flex;

    [dir=rtl] & {
      padding: 60px 150px 0 30px;
    }

    @include media(max, xl) {
      padding-left: 60px;

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 60px;
      }
    }

    @include media(max, lg) {
      padding: 0;
      min-height: 0;
      flex-direction: column-reverse;
      align-items: flex-start;
      background: none;
    }
  }

  .content-info {
    max-width: 370px;
    flex: 0 0 370px;

    @include media(max, lg) {
      margin-top: -20px;
      max-width: 630px;
      flex: 0 0 auto;
    }
  }

  .content-title {
    margin: 0 0 20px;
    font-size: 28px;
    line-height: 1.21;
    font-weight: 700;

    @include media(max, lg) {
      margin-top: 0;
      font-size: 24px;
      line-height: 1.17;
    }
  }

  .content-text {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 1.33;
    font-weight: 400;

    @include media(max, lg) {
      font-size: 16px;
      line-height: 1.38;
    }

    li {
      position: relative;
      padding-left: 28px;

      &:before {
        content: '\2022';
        position: absolute;
        top: 0;
        left: 9px;
      }

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 28px;

        &:before {
          left: auto;
          right: 9px;
        }
      }
    }
  }

  .text-link {
    font-size: 18px;
    line-height: 1.33;
    color: #16a7ff;

    &:hover {
      color: #56bfff;
    }

    svg {
      display: inline-block;
      vertical-align: -4px;
    }

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }

    @include media(max, lg) {
      display: none;
    }
  }

  .btn-action {
    display: none;
    padding: 12px 16px;
    line-height: 32px;

    @include media(max, lg) {
      display: flex;
    }
  }

  .content-screenshot {
    margin-top: 11px;
    text-align: center;
    flex: 1 0 auto;
    max-width: calc(100% - 360px);

    @include media(max, lg) {
      margin: 0 -10px 30px;
      max-width: none;
    }
  }

  .picture {
    display: block;

    img {
      height: auto;
    }
  }
</style>

<template>
  <div class="services-block">
    <h2 class="title">
      {{$t('name')}}
    </h2>

    <div class="wrapper">
      <div class="content-info">
        <h3 class="content-title">
          {{$t('title')}}
        </h3>
        <div class="content-text">
          <ul>
            <li>
              {{$t('descr1')}}
            </li>
            <li>
              {{$t('descr2')}}
            </li>
            <li>
              {{$t('descr3')}}
            </li>
            <li>
              {{$t('descr4')}}
            </li>
            <li>
              {{$t('descr5')}}
            </li>
          </ul>
        </div>
        <a href="https://market.vkplay.ru" class="text-link" target="_blank" rel="noopener noreferrer">
          {{$t('link')}}
          <icon name="angle" />
        </a>
        <btn
          href="https://market.vkplay.ru"
          target="_blank"
          variant="muted"
          class="fs-18 btn-main btn-action">
          {{$t('link')}}
          <icon name="angle"/>
        </btn>
      </div>
      <div class="content-screenshot">
        <picture class="picture">
          <source
            type="image/png"
            :srcset="`${baseUrl}images/b2b/screenshots/${this.getCurrentLang === 'ru' ? 'ru' : 'en'}/market.png 1x, ${baseUrl}/images/b2b/screenshots/${this.getCurrentLang === 'ru' ? 'ru' : 'en'}/market@2x.png 2x`"
          />
          <img
            :src="`${baseUrl}images/b2b/screenshots/${this.getCurrentLang === 'ru' ? 'ru' : 'en'}/market.png`"
            :alt="$t('name')"
            width="770"
            height="427"
          />
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  name: 'Services',
  i18n: {
    messages: {
      ru: {
        name: 'Торговая площадка',
        title: 'Продажа внутриигровых предметов с умной системой ценообразования и возможностью скидок',
        descr1: 'Доступ к многомиллионной аудитории',
        descr2: 'Дополнительный доход и качественный трафик',
        descr3: 'Быстрая и лёгкая интеграция',
        descr4: 'Контроль со стороны разработчика',
        descr5: 'Доступ к статистике',
        link: 'Перейти на Торговую площадку',
      },
      en: {
        name: 'Market',
        title: 'Sell in-game items with smart pricing and the opportunity to offer discounts',
        descr1: 'Access to an audience of millions',
        descr2: 'Additional income and quality traffic',
        descr3: 'Quick and easy integration',
        descr4: 'Developer controls',
        descr5: 'Access to statistics',
        link: 'Go to Market',
      },
      de: {
        name: 'Markt',
        title: 'Verkauf von In-Game-Gegenständen mithilfe eines smarten Preissystems und der Möglichkeit Rabatte anzubieten',
        descr1: 'Zugang zu einem Millionenpublikum',
        descr2: 'Zusatzeinkommen und qualitativ hochwertiger Datenverkehr',
        descr3: 'Schnelle und einfache Integration',
        descr4: 'Kontrolle durch Entwickler',
        descr5: 'Zugriff auf Statistiken',
        link: 'Zum Markt',
      },
      fr: {
        name: 'Marché',
        title: 'Vendez des objets en jeu en fixant des prix intelligents, avec la possibilité de proposer des réductions',
        descr1: 'Accès à un public de plusieurs millions de personnes',
        descr2: 'Revenus supplémentaires et trafic de qualité',
        descr3: 'Intégration rapide et facile',
        descr4: 'Contrôles du développeur',
        descr5: 'Accès aux statistiques',
        link: 'Accéder au Marché',
      },
      es: {
        name: 'Mercado',
        title: 'Vende artículos del juego a precios competitivos y con la posibilidad de ofrecer descuentos',
        descr1: 'Acceso a una audiencia de millones de personas',
        descr2: 'Ingresos adicionales y afluencia asegurada',
        descr3: 'Integración rápida y sencilla',
        descr4: 'Controles de desarrollador',
        descr5: 'Acceso a las estadísticas',
        link: 'Ir al mercado',
      },
      pl: {
        name: 'Rynek',
        title: 'Sprzedawaj przedmioty w grze dzięki inteligentnej wycenie i możliwości oferowania rabatów',
        descr1: 'Dostęp to milionów odbiorców',
        descr2: 'Dodatkowy dochód i ruch wysokiej jakości',
        descr3: 'Szybka i prosta integracja',
        descr4: 'Narzędzia dla twórców',
        descr5: 'Dostęp to danych i statystyk',
        link: 'Przejdź na rynek',
      },
      tr: {
        name: 'Market',
        title: 'Akıllı fiyatlandırma ve indirim sunma fırsatıyla oyun içi eşyalar sat',
        descr1: 'Milyonlarca kişilik kitleye erişim',
        descr2: 'Ek gelir ve kaliteli trafik',
        descr3: 'Hızlı ve kolay entegrasyon',
        descr4: 'Geliştirici kontrolleri',
        descr5: 'İstatistiklere erişim',
        link: 'Markete git',
      },
      ar: {
        name: 'السوق',
        title: 'بع العناصر داخل الألعاب مع تسعير ذكي وفرصة عرض خصومات',
        descr1: 'تمتع بالوصول إلى ملايين المستخدمين',
        descr2: 'دخل إضافي ومرور ذو جودة',
        descr3: 'تكامل سريع وسهل',
        descr4: 'تحكم المطورين',
        descr5: 'الوصول إلى الإحصائيات',
        link: 'الذهاب إلى السوق',
      },
    },
  },
  data() {
    return {
      active: 'market',
    };
  },
  methods: {
    handleTabChange(key) {
      if (key !== this.active) {
        this.active = key;
      }
    },
  },
};

</script>
